var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('feather-icon',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.top",value:(_vm.text),expression:"text",modifiers:{"hover":true,"top":true}}],staticClass:"jb-info-hint",attrs:{"icon":"HelpCircleIcon","size":"13"}})}
var staticRenderFns = []

export { render, staticRenderFns }